import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import QuoteDialog from "./components/QuoteDialog";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Infrastructure from "./pages/Infrastructure";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const [quoteOpen, setQuoteOpen] = React.useState(false);
  const openQuote = () => setQuoteOpen(true);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ScrollToTop />
      <Navbar onGetQuote={openQuote} />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer onGetQuote={openQuote} />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FAFAFA",
            color: "#2A221A",
            border: "1px solid #E8E2D9",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
